import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import AppModel from '../DataModel/AppModel';
import { Link } from 'react-router';
import CircularProgress from 'material-ui/CircularProgress';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Add from 'material-ui/svg-icons/content/add';
import PageLoading from '../components/PageLoading';
import ContractIcon from 'material-ui/svg-icons/action/card-membership';

import right_corner_style from '../utils/right-corner-style';
import {List,ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import {orange500} from 'material-ui/styles/colors';
import {dateStr} from '../utils/TimeFormatter';

const businessColor = orange500;

let pageStyle = {
  margin:"1em",
};

export default
@observer class MachineContractsPage extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }

  gotoNewContractPage() {
    let machine = AppModel.contractForm.machine;
    this.context.router.push(
      `/machine_admin/newContract/${encodeURI(machine.id_customer)}/${encodeURI(machine.id)}`
    );
  }

  gotoContractDetailPage(contract) {
    return () => {
      this.context.router.push(
        `/machine_admin/contract/${encodeURI(contract.id_customer)}/${encodeURI(contract.id_machine)}/${encodeURI(contract.id)}`
      );
    }
  }

  infoLine(contract) {
    if(contract.type=='Buy') {
      return [
        (contract.delivery ? uiMsg('MC_DELIVERY_INFO',"Delivery: <X>",dateStr(contract.delivery)) : null),
        (contract.support_paid_till ? uiMsg('MC_SUPPORT_TILL_INFO',"Support paid till <X>",dateStr(contract.support_paid_till)) : null)
      ].filter(l=>!!l).join(", ")
    }
    return [
      (contract.delivery ? uiMsg('MC_DELIVERY_INFO',"Delivery: <X>",dateStr(contract.delivery)) : null),
      (contract.end_of_contract ? uiMsg('MC_END_OF_CONTRACT',"Rental ends <X>",dateStr(contract.end_of_contract)) : null)
    ].filter(l=>!!l).join(", ")

  }

  render() {
    let customer = AppModel.contractForm.customer
    let machine = AppModel.contractForm.machine
    return (
      <PageLoading loading={
          AppModel.contractListLoading
        || AppModel.fetchingContractFormContext }>
        {AppModel.contractList.length==0 ?
          <div style={pageStyle}>
            <table><tbody>
              <tr>
                <td colSpan={2}>{uiMsg('MC_NO_CONTRACTS_REG_FOR',"No contracts registered for :")}</td>
              </tr>
              <tr>
                <td><b>{uiMsg('MC_CUSTOMER_NAME','Customer')}</b></td>
                <td>{customer.name}</td>
              </tr>
              <tr>
                <td><b>{uiMsg('MC_MACHINE_NAME','Machine')}</b></td>
                <td>{machine.name}</td>
              </tr>
            </tbody></table>
          </div>
          :
          <div style={pageStyle}>
          <table><tbody>
            <tr>
              <td><b>{uiMsg('MC_CUSTOMER_NAME','Customer')}</b></td>
              <td>{customer.name}</td>
            </tr>
            <tr>
              <td><b>{uiMsg('MC_MACHINE_NAME','Machine')}</b></td>
              <td>{machine.name}</td>
            </tr>
          </tbody></table>
        </div>}
        <List>
          {
            AppModel.contractList.map(c =>
              <ListItem
                  key={c.id}
                  value={c.id}
                  leftAvatar={<Avatar icon={<ContractIcon />}
                  backgroundColor={businessColor} />}
                  primaryText={uiMsg('MC_CONTRACT_TYPE','Type')+":"+c.type+
                    ", "+uiMsg('MC_CREATED_AT','Created at ',dateStr(c.created_at))}
                  secondaryText={this.infoLine(c)}
                  onTouchTap={this.gotoContractDetailPage(c)}
              />
          )
        }
      </List>
        {AppModel.canAdminCustomers ?
            <FloatingActionButton style={right_corner_style}
                                children={<Add />}
                                onTouchTap={this.gotoNewContractPage.bind(this)} />
            :null
          }
      </PageLoading>

    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/pages/MachineContractsPage.jsx
 **/